import Section from './src/Section.vue'

Section.install = function (Vue) {
  Vue.component(Section.name, Section)
}

export default Section
